<script lang="ts">
    import type { ActionSetting } from "..";

    export let setting: ActionSetting;
</script>

<!----------------------------------------------------------------------------->

<button id={setting.id} on:click={setting.action}>
    {setting.name}
</button>

<!----------------------------------------------------------------------------->

<style>
    button {
        width: max-content;
    }
</style>
